import React, { useState } from "react";
import {
  Divider,
  Text,
  Title,
  TextInput,
  Flex,
  Badge,
  Box,
  Button,
  Grid,
} from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";

import { LoyaltyMembershipForm } from "./";
import DealerVerification from "@components/RideChallengeApp/DealerVerification";
import { StyledIframe } from "@components/shared/IframeModal";

export default function LoyaltyMembership({
  codeVerificationData,
  membership = null,
  additionalReqData = {},
  fetchData,
  setMembershipInfo,
  userInfo,
  showMembershipSignup = true,
  children,
  rejectUnverified = false,
}) {
  const [showSignup, setShowSignup] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);

  const inactiveMembership = membership && !membership.is_active;

  if (showSignup) {
    return (
      <div>
        <SignupFlow
          reqData={additionalReqData}
          onLeadCreate={() => {
            setShowSignup(false);
            setShowSignupModal(true);
          }}
          codeVerificationData={codeVerificationData}
        />
        <Flex justify="center" mt="xl">
          <Button
            size="xs"
            c="dark"
            color="gray.1"
            radius="lg"
            onClick={() => setShowSignup(false)}
          >
            {inactiveMembership ? "Back" : "I already have a membership"}
          </Button>
        </Flex>
      </div>
    );
  }

  return (
    <div>
      {membership ? (
        <Box>
          <Item
            info={{
              ...membership,
              additional_req_data: additionalReqData,
            }}
            showCorrection={!showMembershipSignup}
            fetchData={fetchData}
          />
          {(children || inactiveMembership) && (
            <Flex justify="center" mt="xl" gap="xs">
              {inactiveMembership && (
                <Button
                  onClick={() => setShowSignup(true)}
                  size="xs"
                  c="dark"
                  color="gray.1"
                  radius="lg"
                >
                  Renew
                </Button>
              )}
              {children}
            </Flex>
          )}
        </Box>
      ) : (
        <Box>
          {/* <Text c="white" fw={600}>
            Add a new membership
          </Text> */}
          <LoyaltyMembershipForm
            additionalReqData={additionalReqData}
            userInfo={userInfo}
            rejectUnverified={rejectUnverified}
            setMembershipInfo={(e) => {
              if (setMembershipInfo) {
                setMembershipInfo(e);
              }
              if (fetchData) {
                fetchData();
              }
            }}
          />
          {showMembershipSignup && (
            <Flex justify="center" mt="xl" gap="xs">
              <Button
                onClick={() => setShowSignup(true)}
                size="xs"
                c="dark"
                color="gray.1"
                radius="lg"
              >
                Join or Renew
              </Button>
              {children}
            </Flex>
          )}
          {/* <Modal
            opened={showSignupModal}
            onClose={() => setShowSignupModal(false)}
            size="lg"
          >
            <StyledIframe src="https://members.harley-davidson.com/HOG/HDMN_Login" />
          </Modal> */}
        </Box>
      )}
    </div>
  );
}

const Item = ({ info, fetchData, showCorrection }) => {
  const [loading, setLoading] = useState(false);
  const [statusInfo, setStatusInfo] = useState(null);
  const [correctionVisible, setCorrectionVisible] = useState(false);

  function onStatusCheck() {
    setLoading(true);

    const req = {
      loyalty_membership_id: info.id,
    };

    axios
      .post(`/loyalty-memberships/status-check/`, req)
      .then(({ data }) => {
        setLoading(false);
        setStatusInfo(data.response[0]);
        if (fetchData) {
          fetchData();
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  if (correctionVisible) {
    return (
      <div>
        <MakeCorrection
          info={info}
          onCancelClick={() => setCorrectionVisible(false)}
          fetchData={() => {
            setCorrectionVisible(false);
            fetchData();
          }}
        />
      </div>
    );
  }

  return (
    <div>
      <Flex justify="center" gap="xs" align="center">
        <Title order={1} c="white">
          {info.ident}
        </Title>
        {info.is_active ? (
          <Badge color="green" size="xs">
            Active
          </Badge>
        ) : (
          <Badge color="red" size="xs">
            Inactive
          </Badge>
        )}
      </Flex>
      {info.initial_activation_date && (
        <Text align="center" c="white">
          Member since{" "}
          {new Date(info.initial_activation_date).toLocaleDateString()}
        </Text>
      )}
      <Text align="center" size="xs" c="dimmed">
        last verified {new Date(info.last_verified_at).toLocaleString()}
      </Text>
      {statusInfo && (
        <Box my="lg">
          <Text align="center" size="md" c="white">
            Verified: {statusInfo.verified ? "Yes" : "No"}
          </Text>
          <Text align="center" size="md" c="white">
            Active: {statusInfo.is_active ? "Yes" : "No"}
          </Text>
        </Box>
      )}
      {!info.loyalty_membership_id && (
        <Flex justify="center" mt="md" gap="xs">
          <Button
            size="sm"
            // variant="light"
            onClick={onStatusCheck}
            loading={loading}
            radius="xl"
          >
            Check Status
          </Button>
          {showCorrection && (
            <Button
              variant="subtle"
              size="sm"
              color="gray"
              radius="xl"
              onClick={() => setCorrectionVisible(true)}
            >
              Make Correction
            </Button>
          )}
        </Flex>
      )}
    </div>
  );
};

const SignupFlow = ({ onLeadCreate, reqData, codeVerificationData }) => {
  const [showDealerCode, setShowDealerCode] = useState(false);

  function createLead(remoteCodeData = null) {
    const req = { ...reqData, variety: 1 };
    delete req.check;

    if (remoteCodeData) {
      req.remote_code_id = remoteCodeData.id;
    }

    axios
      .post(`/leads/`, req)
      .then(() => {
        openMembership();
        onLeadCreate();
      })
      .catch((err) => {
        toast.error(err);
        openMembership();
        onLeadCreate();
      });
  }

  function openMembership() {
    setTimeout(() => {
      window.open(
        "https://members.harley-davidson.com/HOG/HDMN_Login",
        "_blank"
      );
    });
  }

  if (showDealerCode) {
    return (
      <div>
        <DealerVerification
          codeVerificationData={codeVerificationData}
          setDealerCodeData={(e) => {
            createLead(e);
          }}
        />
        <Flex justify="center" mt="lg">
          <Button variant="light" onClick={() => setShowDealerCode(false)}>
            Cancel
          </Button>
        </Flex>
      </div>
    );
  }

  return (
    <div>
      <Text c="white" fw={600} align="center" size="lg" mb="sm">
        Are you working with an HD rep?
      </Text>
      <Flex justify="center" gap="xl">
        <Button onClick={() => setShowDealerCode(true)}>Yes</Button>
        <Button color="red" onClick={createLead}>
          No
        </Button>
      </Flex>
    </div>
  );
};

const MakeCorrection = ({ info, fetchData, onCancelClick }) => {
  const [membershipInfo, setMembershipInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");

  function checkStatus() {
    setLoading(true);

    const req = {
      loyalty_membership_ident: value,
      loyalty_membership_id: info.id,
      user_id: info.user_id,
      variety: info.variety,
      campaign_effort_id: info?.additional_req_data?.campaign_effort_id,
    };

    axios
      .post(`/loyalty-memberships/status-check/`, req)
      .then(({ data }) => {
        setMembershipInfo({
          ...data.response[0],
        });
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSubmit() {
    const req = {
      loyalty_membership_ident: value,
      loyalty_membership_id: info.id,
      user_id: info.user_id,
      variety: info.variety,
      campaign_effort_id: info?.additional_req_data?.campaign_effort_id,
    };

    setLoading(true);

    axios
      .post(`/ride-challenge/hog-correction/`, req)
      .then(() => {
        toast.success("Membership updated!");
        fetchData();
        setValue("");
        setMembershipInfo(null);
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  if (membershipInfo) {
    const showRollup = !membershipInfo.in_use && membershipInfo.verified;

    return (
      <div>
        {/* Current Membership: {info.ident} */}
        <Flex justify="center" gap="xs" align="center">
          <Title order={1} c="white">
            {value}
          </Title>
          {showRollup && (
            <>
              {membershipInfo.is_active ? (
                <Badge color="green" size="xs">
                  Active
                </Badge>
              ) : (
                <Badge color="red" size="xs">
                  Inactive
                </Badge>
              )}
            </>
          )}
        </Flex>
        {showRollup && (
          <Text align="center" size="xs" c="dimmed">
            current membership: {info.ident}
          </Text>
        )}
        {membershipInfo.in_use && (
          <>
            <Text align="center" c="red" fw={600} size="md">
              This membership number is in use by another user.
            </Text>
            <Flex justify="center" mt="md" gap="md">
              <CancelButton onClick={onCancelClick} />
            </Flex>
          </>
        )}
        {!membershipInfo.verified && !membershipInfo.in_use && (
          <>
            <Text align="center" c="red" fw={600} size="md">
              This membership number is not verified.
            </Text>
            <Flex justify="center" mt="md" gap="md">
              <CancelButton onClick={onCancelClick} />
            </Flex>
          </>
        )}
        {showRollup && (
          <Box mt="md">
            {membershipInfo.is_active ? (
              <Text c="white" fw={600} align="center">
                This membership is{" "}
                <span style={{ color: "var(--mantine-color-green-4)" }}>
                  active
                </span>
                .
              </Text>
            ) : (
              <Text c="white" fw={600} align="center">
                This membership is{" "}
                <span style={{ color: "var(--mantine-color-red-4)" }}>
                  inactive
                </span>
                .
              </Text>
            )}
            {membershipInfo.user_vehicles.length > 0 ? (
              <Box mt="md" mb="xl">
                <Text
                  w="50%"
                  mx="auto"
                  c="white"
                  mb="xl"
                  fw={600}
                  align="center"
                >
                  If you confirm the correction, this membership ({value}) will
                  be assigned to the following vehicles (
                  {membershipInfo.user_vehicles.length}) and user vehicle
                  datapoints (
                  {membershipInfo.user_vehicles.reduce(
                    (acc, vehicle) =>
                      acc +
                      vehicle.user_vehicle_data_points.filter(
                        (f) => f.is_active
                      ).length,
                    0
                  )}
                  ):
                </Text>
                <Grid gutter="xs" justify="center" wrap="wrap">
                  {membershipInfo.user_vehicles.map((vehicle) => {
                    const uvdps = vehicle.user_vehicle_data_points.filter(
                      (f) => f.is_active
                    );
                    const hasUvdps = uvdps.length > 0;
                    return (
                      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                        <Box
                          p="md"
                          style={{
                            backgroundColor: "var(--mantine-color-dark-4)",
                            borderRadius: "var(--mantine-radius-md)",
                            border: "1px solid var(--mantine-color-dark-3)",
                          }}
                          key={vehicle.id}
                        >
                          <Text
                            align="center"
                            c="white"
                            size="sm"
                            fw={600}
                            key={vehicle.id}
                          >
                            {vehicle.year} {vehicle.make} {vehicle.model}
                            {vehicle.series && ` ${vehicle.series}`}
                          </Text>
                          <Text size="xs" c="gray.4" align="center">
                            {vehicle.vin.toUpperCase()}
                          </Text>
                          {hasUvdps && (
                            <Text c="gray.4" align="center" size="xs">
                              {uvdps.length} UVDPs changed
                            </Text>
                          )}
                        </Box>
                      </Grid.Col>
                    );
                  })}
                </Grid>
              </Box>
            ) : (
              <Box mt="md" mb="xl">
                <Text fw={600} align="center" c="white">
                  There are no UVDPs to be changed. It is safe to submit this
                  correction.
                </Text>
              </Box>
            )}
            <Flex justify="center" mt="xl" gap="md" mb="lg">
              <Button onClick={onSubmit} loading={loading} radius="xl">
                Confirm Correction
              </Button>
              <CancelButton onClick={onCancelClick} />
            </Flex>
          </Box>
        )}
      </div>
    );
  }

  return (
    <div>
      <Text fw={600} c="white">
        Current Membership: {info.ident}
      </Text>
      <Divider my="sm" />
      <TextInput
        label="Member ID (e.g. US1234567)"
        value={value}
        onChange={(e) => setValue(e.target.value.trim().toUpperCase())}
        size="lg"
      />
      <Button
        loading={loading}
        mt="xs"
        fullWidth
        disabled={!value}
        onClick={checkStatus}
        size="lg"
      >
        Submit
      </Button>
      <Flex justify="center" mt="md">
        <CancelButton onClick={onCancelClick} />
      </Flex>
    </div>
  );
};

const CancelButton = ({ onClick }) => (
  <Button onClick={onClick} variant="subtle" color="gray" radius="xl">
    Cancel Correction
  </Button>
);
